import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
export interface ObjectKeys {
  key: string,
  value: string
}
@Component({
  selector: 'ipm-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss']
})
export class ButtonToggleComponent implements OnInit{
  @Input() selectedValue: string = "";
  @Input() textArray: Array<ObjectKeys> = [];
  @Input() renderType: any = "";
  @Output() onChangeToggleButtonEvent: EventEmitter<any> = new EventEmitter();

  // Unique per-instance id so multiple toggles on the same page (e.g. a parent
  // layout filter and a child component filter) don't share the same radio
  // group name and interfere with each other.
  private static nextInstanceId = 0;
  readonly groupName: string = `switchPlan-${ButtonToggleComponent.nextInstanceId++}`;

  constructor() {}
  ngOnInit(): void {
    
  }

  get isThreeOptions(): boolean {
    return this.textArray && this.textArray.length === 3;
  }

  onChangeToggle($event: any) {
    this.onChangeToggleButtonEvent.emit($event?.target.value);
  }
}
